export default __webpack_public_path__ + "static/media/tk.c63f020a.svg";